// Local Visibility + Google Business Profile pricing shown on the site.
// The backend re-validates every amount; these are display values only.

export const PRICES = {
  gbpSetup: 299,
  onboarding: 149,
  monthly: 299,
  addon: 49,
};

export const PLATFORMS = [
  { value: "facebook", label: "Facebook Page", short: "Facebook" },
  { value: "instagram", label: "Instagram professional account", short: "Instagram" },
];

export const platformLabel = (v, short = false) => {
  const p = PLATFORMS.find((x) => x.value === v);
  return p ? (short ? p.short : p.label) : v;
};

export const otherPlatform = (v) => PLATFORMS.find((p) => p.value !== v);

export const monthlyTotal = (addSecond) => PRICES.monthly + (addSecond ? PRICES.addon : 0);

export const dollars = (cents) => `$${Math.round(cents / 100)}`;
